/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NosidebarPlanningRouteImport } from './routes/_nosidebar/planning'
import { Route as AuthenticatedTodayRouteImport } from './routes/_authenticated/today'
import { Route as AuthenticatedStorePricingRouteImport } from './routes/_authenticated/store-pricing'
import { Route as AuthenticatedFeatureFlagsRouteImport } from './routes/_authenticated/feature-flags'
import { Route as AuthenticatedCartsControlRouteImport } from './routes/_authenticated/carts-control'
import { Route as AuthenticatedCartsRouteImport } from './routes/_authenticated/carts'
import { Route as AuthenticatedCartVisionChecksRouteImport } from './routes/_authenticated/cart-vision-checks'
import { Route as AuthenticatedCartPhotosX7k2qzRouteImport } from './routes/_authenticated/cart-photos-x7k2qz'
import { Route as AuthenticatedAccountingRouteImport } from './routes/_authenticated/accounting'
import { Route as AuthenticatedCamerasRouteRouteImport } from './routes/_authenticated/cameras/route'
import { Route as AuthenticatedVisioReviewsIndexRouteImport } from './routes/_authenticated/visio-reviews/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedStoresIndexRouteImport } from './routes/_authenticated/stores/index'
import { Route as AuthenticatedSensorsIndexRouteImport } from './routes/_authenticated/sensors/index'
import { Route as AuthenticatedSellersIndexRouteImport } from './routes/_authenticated/sellers/index'
import { Route as AuthenticatedQualityIndexRouteImport } from './routes/_authenticated/quality/index'
import { Route as AuthenticatedPromoCampaignIndexRouteImport } from './routes/_authenticated/promo-campaign/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedPreAuthorizationsIndexRouteImport } from './routes/_authenticated/pre-authorizations/index'
import { Route as AuthenticatedPlatformStocksIndexRouteImport } from './routes/_authenticated/platform-stocks/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedNetworkDashboardIndexRouteImport } from './routes/_authenticated/network-dashboard/index'
import { Route as AuthenticatedMailingListsIndexRouteImport } from './routes/_authenticated/mailing-lists/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDailySalesIndexRouteImport } from './routes/_authenticated/daily-sales/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedCategoriesIndexRouteImport } from './routes/_authenticated/categories/index'
import { Route as AuthenticatedCamerasIndexRouteImport } from './routes/_authenticated/cameras/index'
import { Route as AuthenticatedCamerasViewsIndexRouteImport } from './routes/_authenticated/cameras-views/index'
import { Route as NosidebarWorkshiftAttendanceStoreIdRouteImport } from './routes/_nosidebar/workshift-attendance.$storeId'
import { Route as AuthenticatedVisioReviewsAdminRouteImport } from './routes/_authenticated/visio-reviews/admin'
import { Route as AuthenticatedUsersNewRouteImport } from './routes/_authenticated/users/new'
import { Route as AuthenticatedStoresNewRouteImport } from './routes/_authenticated/stores/new'
import { Route as AuthenticatedSensorsNewRouteImport } from './routes/_authenticated/sensors/new'
import { Route as AuthenticatedSellersNewRouteImport } from './routes/_authenticated/sellers/new'
import { Route as AuthenticatedQualityLotRouteImport } from './routes/_authenticated/quality/$lot'
import { Route as AuthenticatedPromoCampaignNewRouteImport } from './routes/_authenticated/promo-campaign/new'
import { Route as AuthenticatedProductsNewRouteImport } from './routes/_authenticated/products/new'
import { Route as AuthenticatedProductsImportRouteImport } from './routes/_authenticated/products/import'
import { Route as AuthenticatedNotificationsNewRouteImport } from './routes/_authenticated/notifications/new'
import { Route as AuthenticatedNotificationsIdRouteImport } from './routes/_authenticated/notifications/$id'
import { Route as AuthenticatedMailingListsKeyRouteImport } from './routes/_authenticated/mailing-lists/$key'
import { Route as AuthenticatedHrSmsTrackingRouteImport } from './routes/_authenticated/hr/sms-tracking'
import { Route as AuthenticatedHrInterimAgenciesRouteImport } from './routes/_authenticated/hr/interim-agencies'
import { Route as AuthenticatedDashboardHoursRouteImport } from './routes/_authenticated/dashboard/hours'
import { Route as AuthenticatedCompaniesNewRouteImport } from './routes/_authenticated/companies/new'
import { Route as AuthenticatedCategoriesNewRouteImport } from './routes/_authenticated/categories/new'
import { Route as AuthenticatedCamerasConfigRouteImport } from './routes/_authenticated/cameras/config'
import { Route as AuthenticatedCamerasViewsNewRouteImport } from './routes/_authenticated/cameras-views/new'
import { Route as AuthenticatedAdminsNewRouteImport } from './routes/_authenticated/admins/new'
import { Route as AuthenticatedStoresStoreIdIndexRouteImport } from './routes/_authenticated/stores/$storeId.index'
import { Route as AuthenticatedProductsProductIdIndexRouteImport } from './routes/_authenticated/products/$productId.index'
import { Route as AuthenticatedHrPlanningIndexRouteImport } from './routes/_authenticated/hr/planning.index'
import { Route as AuthenticatedDevelopmentRealEstateIndexRouteImport } from './routes/_authenticated/development/real-estate.index'
import { Route as AuthenticatedAdministrationRolesIndexRouteImport } from './routes/_authenticated/administration/roles/index'
import { Route as AuthenticatedSensorsFridgeNewRouteImport } from './routes/_authenticated/sensors/fridge.new'
import { Route as AuthenticatedSellersEstablishmentNewRouteImport } from './routes/_authenticated/sellers/establishment.new'
import { Route as AuthenticatedProductsProductIdEditRouteImport } from './routes/_authenticated/products/$productId.edit'
import { Route as AuthenticatedPreAuthorizationsSessionIdRecordingsRouteImport } from './routes/_authenticated/pre-authorizations/$sessionId.recordings'
import { Route as AuthenticatedHrPlanningTabRouteImport } from './routes/_authenticated/hr/planning.$tab'
import { Route as AuthenticatedDevelopmentRealEstateTabRouteImport } from './routes/_authenticated/development/real-estate.$tab'
import { Route as AuthenticatedDailySalesStockMinImportRouteImport } from './routes/_authenticated/daily-sales/stock-min.import'
import { Route as AuthenticatedCompaniesIdEditRouteImport } from './routes/_authenticated/companies/$id.edit'
import { Route as AuthenticatedCategoriesReapproNewRouteImport } from './routes/_authenticated/categories/reappro.new'
import { Route as AuthenticatedCategoriesReapproConfigRouteImport } from './routes/_authenticated/categories/reappro.config'
import { Route as AuthenticatedCategoriesInternalNewRouteImport } from './routes/_authenticated/categories/internal.new'
import { Route as AuthenticatedCategoriesBrandNewRouteImport } from './routes/_authenticated/categories/brand.new'
import { Route as AuthenticatedCamerasViewsViewIdEditRouteImport } from './routes/_authenticated/cameras-views/$viewId.edit'
import { Route as AuthenticatedAdminsIdEditRouteImport } from './routes/_authenticated/admins/$id.edit'
import { Route as AuthenticatedAdministrationRolesNewRouteImport } from './routes/_authenticated/administration/roles/new'
import { Route as AuthenticatedAdministrationRolesRoleIdIndexRouteImport } from './routes/_authenticated/administration/roles/$roleId.index'
import { Route as AuthenticatedStoresStoreIdInventoriesInventoryIdRouteImport } from './routes/_authenticated/stores/$storeId.inventories.$inventoryId'
import { Route as AuthenticatedAdministrationRolesRoleIdEditRouteImport } from './routes/_authenticated/administration/roles/$roleId.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NosidebarPlanningRoute = NosidebarPlanningRouteImport.update({
  id: '/_nosidebar/planning',
  path: '/planning',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTodayRoute = AuthenticatedTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedStorePricingRoute =
  AuthenticatedStorePricingRouteImport.update({
    id: '/store-pricing',
    path: '/store-pricing',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFeatureFlagsRoute =
  AuthenticatedFeatureFlagsRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCartsControlRoute =
  AuthenticatedCartsControlRouteImport.update({
    id: '/carts-control',
    path: '/carts-control',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCartsRoute = AuthenticatedCartsRouteImport.update({
  id: '/carts',
  path: '/carts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCartVisionChecksRoute =
  AuthenticatedCartVisionChecksRouteImport.update({
    id: '/cart-vision-checks',
    path: '/cart-vision-checks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCartPhotosX7k2qzRoute =
  AuthenticatedCartPhotosX7k2qzRouteImport.update({
    id: '/cart-photos-x7k2qz',
    path: '/cart-photos-x7k2qz',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccountingRoute = AuthenticatedAccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCamerasRouteRoute =
  AuthenticatedCamerasRouteRouteImport.update({
    id: '/cameras',
    path: '/cameras',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedVisioReviewsIndexRoute =
  AuthenticatedVisioReviewsIndexRouteImport.update({
    id: '/visio-reviews/',
    path: '/visio-reviews/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedStoresIndexRoute =
  AuthenticatedStoresIndexRouteImport.update({
    id: '/stores/',
    path: '/stores/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSensorsIndexRoute =
  AuthenticatedSensorsIndexRouteImport.update({
    id: '/sensors/',
    path: '/sensors/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSellersIndexRoute =
  AuthenticatedSellersIndexRouteImport.update({
    id: '/sellers/',
    path: '/sellers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQualityIndexRoute =
  AuthenticatedQualityIndexRouteImport.update({
    id: '/quality/',
    path: '/quality/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromoCampaignIndexRoute =
  AuthenticatedPromoCampaignIndexRouteImport.update({
    id: '/promo-campaign/',
    path: '/promo-campaign/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPreAuthorizationsIndexRoute =
  AuthenticatedPreAuthorizationsIndexRouteImport.update({
    id: '/pre-authorizations/',
    path: '/pre-authorizations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPlatformStocksIndexRoute =
  AuthenticatedPlatformStocksIndexRouteImport.update({
    id: '/platform-stocks/',
    path: '/platform-stocks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNetworkDashboardIndexRoute =
  AuthenticatedNetworkDashboardIndexRouteImport.update({
    id: '/network-dashboard/',
    path: '/network-dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMailingListsIndexRoute =
  AuthenticatedMailingListsIndexRouteImport.update({
    id: '/mailing-lists/',
    path: '/mailing-lists/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDailySalesIndexRoute =
  AuthenticatedDailySalesIndexRouteImport.update({
    id: '/daily-sales/',
    path: '/daily-sales/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesIndexRoute =
  AuthenticatedCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCamerasIndexRoute =
  AuthenticatedCamerasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCamerasRouteRoute,
  } as any)
const AuthenticatedCamerasViewsIndexRoute =
  AuthenticatedCamerasViewsIndexRouteImport.update({
    id: '/cameras-views/',
    path: '/cameras-views/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const NosidebarWorkshiftAttendanceStoreIdRoute =
  NosidebarWorkshiftAttendanceStoreIdRouteImport.update({
    id: '/_nosidebar/workshift-attendance/$storeId',
    path: '/workshift-attendance/$storeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedVisioReviewsAdminRoute =
  AuthenticatedVisioReviewsAdminRouteImport.update({
    id: '/visio-reviews/admin',
    path: '/visio-reviews/admin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersNewRoute = AuthenticatedUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedStoresNewRoute = AuthenticatedStoresNewRouteImport.update({
  id: '/stores/new',
  path: '/stores/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSensorsNewRoute = AuthenticatedSensorsNewRouteImport.update({
  id: '/sensors/new',
  path: '/sensors/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSellersNewRoute = AuthenticatedSellersNewRouteImport.update({
  id: '/sellers/new',
  path: '/sellers/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedQualityLotRoute = AuthenticatedQualityLotRouteImport.update({
  id: '/quality/$lot',
  path: '/quality/$lot',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPromoCampaignNewRoute =
  AuthenticatedPromoCampaignNewRouteImport.update({
    id: '/promo-campaign/new',
    path: '/promo-campaign/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsNewRoute =
  AuthenticatedProductsNewRouteImport.update({
    id: '/products/new',
    path: '/products/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsImportRoute =
  AuthenticatedProductsImportRouteImport.update({
    id: '/products/import',
    path: '/products/import',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsNewRoute =
  AuthenticatedNotificationsNewRouteImport.update({
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsIdRoute =
  AuthenticatedNotificationsIdRouteImport.update({
    id: '/notifications/$id',
    path: '/notifications/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMailingListsKeyRoute =
  AuthenticatedMailingListsKeyRouteImport.update({
    id: '/mailing-lists/$key',
    path: '/mailing-lists/$key',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHrSmsTrackingRoute =
  AuthenticatedHrSmsTrackingRouteImport.update({
    id: '/hr/sms-tracking',
    path: '/hr/sms-tracking',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHrInterimAgenciesRoute =
  AuthenticatedHrInterimAgenciesRouteImport.update({
    id: '/hr/interim-agencies',
    path: '/hr/interim-agencies',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHoursRoute =
  AuthenticatedDashboardHoursRouteImport.update({
    id: '/dashboard/hours',
    path: '/dashboard/hours',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesNewRoute =
  AuthenticatedCompaniesNewRouteImport.update({
    id: '/companies/new',
    path: '/companies/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesNewRoute =
  AuthenticatedCategoriesNewRouteImport.update({
    id: '/categories/new',
    path: '/categories/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCamerasConfigRoute =
  AuthenticatedCamerasConfigRouteImport.update({
    id: '/config',
    path: '/config',
    getParentRoute: () => AuthenticatedCamerasRouteRoute,
  } as any)
const AuthenticatedCamerasViewsNewRoute =
  AuthenticatedCamerasViewsNewRouteImport.update({
    id: '/cameras-views/new',
    path: '/cameras-views/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminsNewRoute = AuthenticatedAdminsNewRouteImport.update({
  id: '/admins/new',
  path: '/admins/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedStoresStoreIdIndexRoute =
  AuthenticatedStoresStoreIdIndexRouteImport.update({
    id: '/stores/$storeId/',
    path: '/stores/$storeId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsProductIdIndexRoute =
  AuthenticatedProductsProductIdIndexRouteImport.update({
    id: '/products/$productId/',
    path: '/products/$productId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHrPlanningIndexRoute =
  AuthenticatedHrPlanningIndexRouteImport.update({
    id: '/hr/planning/',
    path: '/hr/planning/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateIndexRoute =
  AuthenticatedDevelopmentRealEstateIndexRouteImport.update({
    id: '/development/real-estate/',
    path: '/development/real-estate/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesIndexRoute =
  AuthenticatedAdministrationRolesIndexRouteImport.update({
    id: '/administration/roles/',
    path: '/administration/roles/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSensorsFridgeNewRoute =
  AuthenticatedSensorsFridgeNewRouteImport.update({
    id: '/sensors/fridge/new',
    path: '/sensors/fridge/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSellersEstablishmentNewRoute =
  AuthenticatedSellersEstablishmentNewRouteImport.update({
    id: '/sellers/establishment/new',
    path: '/sellers/establishment/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProductsProductIdEditRoute =
  AuthenticatedProductsProductIdEditRouteImport.update({
    id: '/products/$productId/edit',
    path: '/products/$productId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPreAuthorizationsSessionIdRecordingsRoute =
  AuthenticatedPreAuthorizationsSessionIdRecordingsRouteImport.update({
    id: '/pre-authorizations/$sessionId/recordings',
    path: '/pre-authorizations/$sessionId/recordings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHrPlanningTabRoute =
  AuthenticatedHrPlanningTabRouteImport.update({
    id: '/hr/planning/$tab',
    path: '/hr/planning/$tab',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDevelopmentRealEstateTabRoute =
  AuthenticatedDevelopmentRealEstateTabRouteImport.update({
    id: '/development/real-estate/$tab',
    path: '/development/real-estate/$tab',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDailySalesStockMinImportRoute =
  AuthenticatedDailySalesStockMinImportRouteImport.update({
    id: '/daily-sales/stock-min/import',
    path: '/daily-sales/stock-min/import',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCompaniesIdEditRoute =
  AuthenticatedCompaniesIdEditRouteImport.update({
    id: '/companies/$id/edit',
    path: '/companies/$id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesReapproNewRoute =
  AuthenticatedCategoriesReapproNewRouteImport.update({
    id: '/categories/reappro/new',
    path: '/categories/reappro/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesReapproConfigRoute =
  AuthenticatedCategoriesReapproConfigRouteImport.update({
    id: '/categories/reappro/config',
    path: '/categories/reappro/config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesInternalNewRoute =
  AuthenticatedCategoriesInternalNewRouteImport.update({
    id: '/categories/internal/new',
    path: '/categories/internal/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCategoriesBrandNewRoute =
  AuthenticatedCategoriesBrandNewRouteImport.update({
    id: '/categories/brand/new',
    path: '/categories/brand/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCamerasViewsViewIdEditRoute =
  AuthenticatedCamerasViewsViewIdEditRouteImport.update({
    id: '/cameras-views/$viewId/edit',
    path: '/cameras-views/$viewId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminsIdEditRoute =
  AuthenticatedAdminsIdEditRouteImport.update({
    id: '/admins/$id/edit',
    path: '/admins/$id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesNewRoute =
  AuthenticatedAdministrationRolesNewRouteImport.update({
    id: '/administration/roles/new',
    path: '/administration/roles/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesRoleIdIndexRoute =
  AuthenticatedAdministrationRolesRoleIdIndexRouteImport.update({
    id: '/administration/roles/$roleId/',
    path: '/administration/roles/$roleId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStoresStoreIdInventoriesInventoryIdRoute =
  AuthenticatedStoresStoreIdInventoriesInventoryIdRouteImport.update({
    id: '/stores/$storeId/inventories/$inventoryId',
    path: '/stores/$storeId/inventories/$inventoryId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdministrationRolesRoleIdEditRoute =
  AuthenticatedAdministrationRolesRoleIdEditRouteImport.update({
    id: '/administration/roles/$roleId/edit',
    path: '/administration/roles/$roleId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/cameras': typeof AuthenticatedCamerasRouteRouteWithChildren
  '/accounting': typeof AuthenticatedAccountingRoute
  '/cart-photos-x7k2qz': typeof AuthenticatedCartPhotosX7k2qzRoute
  '/cart-vision-checks': typeof AuthenticatedCartVisionChecksRoute
  '/carts': typeof AuthenticatedCartsRoute
  '/carts-control': typeof AuthenticatedCartsControlRoute
  '/feature-flags': typeof AuthenticatedFeatureFlagsRoute
  '/store-pricing': typeof AuthenticatedStorePricingRoute
  '/today': typeof AuthenticatedTodayRoute
  '/planning': typeof NosidebarPlanningRoute
  '/admins/new': typeof AuthenticatedAdminsNewRoute
  '/cameras-views/new': typeof AuthenticatedCamerasViewsNewRoute
  '/cameras/config': typeof AuthenticatedCamerasConfigRoute
  '/categories/new': typeof AuthenticatedCategoriesNewRoute
  '/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/dashboard/hours': typeof AuthenticatedDashboardHoursRoute
  '/hr/interim-agencies': typeof AuthenticatedHrInterimAgenciesRoute
  '/hr/sms-tracking': typeof AuthenticatedHrSmsTrackingRoute
  '/mailing-lists/$key': typeof AuthenticatedMailingListsKeyRoute
  '/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/products/import': typeof AuthenticatedProductsImportRoute
  '/products/new': typeof AuthenticatedProductsNewRoute
  '/promo-campaign/new': typeof AuthenticatedPromoCampaignNewRoute
  '/quality/$lot': typeof AuthenticatedQualityLotRoute
  '/sellers/new': typeof AuthenticatedSellersNewRoute
  '/sensors/new': typeof AuthenticatedSensorsNewRoute
  '/stores/new': typeof AuthenticatedStoresNewRoute
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/visio-reviews/admin': typeof AuthenticatedVisioReviewsAdminRoute
  '/workshift-attendance/$storeId': typeof NosidebarWorkshiftAttendanceStoreIdRoute
  '/cameras-views/': typeof AuthenticatedCamerasViewsIndexRoute
  '/cameras/': typeof AuthenticatedCamerasIndexRoute
  '/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/daily-sales/': typeof AuthenticatedDailySalesIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/mailing-lists/': typeof AuthenticatedMailingListsIndexRoute
  '/network-dashboard/': typeof AuthenticatedNetworkDashboardIndexRoute
  '/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/platform-stocks/': typeof AuthenticatedPlatformStocksIndexRoute
  '/pre-authorizations/': typeof AuthenticatedPreAuthorizationsIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/promo-campaign/': typeof AuthenticatedPromoCampaignIndexRoute
  '/quality/': typeof AuthenticatedQualityIndexRoute
  '/sellers/': typeof AuthenticatedSellersIndexRoute
  '/sensors/': typeof AuthenticatedSensorsIndexRoute
  '/stores/': typeof AuthenticatedStoresIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/visio-reviews/': typeof AuthenticatedVisioReviewsIndexRoute
  '/administration/roles/new': typeof AuthenticatedAdministrationRolesNewRoute
  '/admins/$id/edit': typeof AuthenticatedAdminsIdEditRoute
  '/cameras-views/$viewId/edit': typeof AuthenticatedCamerasViewsViewIdEditRoute
  '/categories/brand/new': typeof AuthenticatedCategoriesBrandNewRoute
  '/categories/internal/new': typeof AuthenticatedCategoriesInternalNewRoute
  '/categories/reappro/config': typeof AuthenticatedCategoriesReapproConfigRoute
  '/categories/reappro/new': typeof AuthenticatedCategoriesReapproNewRoute
  '/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/daily-sales/stock-min/import': typeof AuthenticatedDailySalesStockMinImportRoute
  '/development/real-estate/$tab': typeof AuthenticatedDevelopmentRealEstateTabRoute
  '/hr/planning/$tab': typeof AuthenticatedHrPlanningTabRoute
  '/pre-authorizations/$sessionId/recordings': typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/sellers/establishment/new': typeof AuthenticatedSellersEstablishmentNewRoute
  '/sensors/fridge/new': typeof AuthenticatedSensorsFridgeNewRoute
  '/administration/roles/': typeof AuthenticatedAdministrationRolesIndexRoute
  '/development/real-estate/': typeof AuthenticatedDevelopmentRealEstateIndexRoute
  '/hr/planning/': typeof AuthenticatedHrPlanningIndexRoute
  '/products/$productId/': typeof AuthenticatedProductsProductIdIndexRoute
  '/stores/$storeId/': typeof AuthenticatedStoresStoreIdIndexRoute
  '/administration/roles/$roleId/edit': typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  '/stores/$storeId/inventories/$inventoryId': typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  '/administration/roles/$roleId/': typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/accounting': typeof AuthenticatedAccountingRoute
  '/cart-photos-x7k2qz': typeof AuthenticatedCartPhotosX7k2qzRoute
  '/cart-vision-checks': typeof AuthenticatedCartVisionChecksRoute
  '/carts': typeof AuthenticatedCartsRoute
  '/carts-control': typeof AuthenticatedCartsControlRoute
  '/feature-flags': typeof AuthenticatedFeatureFlagsRoute
  '/store-pricing': typeof AuthenticatedStorePricingRoute
  '/today': typeof AuthenticatedTodayRoute
  '/planning': typeof NosidebarPlanningRoute
  '/admins/new': typeof AuthenticatedAdminsNewRoute
  '/cameras-views/new': typeof AuthenticatedCamerasViewsNewRoute
  '/cameras/config': typeof AuthenticatedCamerasConfigRoute
  '/categories/new': typeof AuthenticatedCategoriesNewRoute
  '/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/dashboard/hours': typeof AuthenticatedDashboardHoursRoute
  '/hr/interim-agencies': typeof AuthenticatedHrInterimAgenciesRoute
  '/hr/sms-tracking': typeof AuthenticatedHrSmsTrackingRoute
  '/mailing-lists/$key': typeof AuthenticatedMailingListsKeyRoute
  '/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/products/import': typeof AuthenticatedProductsImportRoute
  '/products/new': typeof AuthenticatedProductsNewRoute
  '/promo-campaign/new': typeof AuthenticatedPromoCampaignNewRoute
  '/quality/$lot': typeof AuthenticatedQualityLotRoute
  '/sellers/new': typeof AuthenticatedSellersNewRoute
  '/sensors/new': typeof AuthenticatedSensorsNewRoute
  '/stores/new': typeof AuthenticatedStoresNewRoute
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/visio-reviews/admin': typeof AuthenticatedVisioReviewsAdminRoute
  '/workshift-attendance/$storeId': typeof NosidebarWorkshiftAttendanceStoreIdRoute
  '/cameras-views': typeof AuthenticatedCamerasViewsIndexRoute
  '/cameras': typeof AuthenticatedCamerasIndexRoute
  '/categories': typeof AuthenticatedCategoriesIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/daily-sales': typeof AuthenticatedDailySalesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/mailing-lists': typeof AuthenticatedMailingListsIndexRoute
  '/network-dashboard': typeof AuthenticatedNetworkDashboardIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/platform-stocks': typeof AuthenticatedPlatformStocksIndexRoute
  '/pre-authorizations': typeof AuthenticatedPreAuthorizationsIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/promo-campaign': typeof AuthenticatedPromoCampaignIndexRoute
  '/quality': typeof AuthenticatedQualityIndexRoute
  '/sellers': typeof AuthenticatedSellersIndexRoute
  '/sensors': typeof AuthenticatedSensorsIndexRoute
  '/stores': typeof AuthenticatedStoresIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/visio-reviews': typeof AuthenticatedVisioReviewsIndexRoute
  '/administration/roles/new': typeof AuthenticatedAdministrationRolesNewRoute
  '/admins/$id/edit': typeof AuthenticatedAdminsIdEditRoute
  '/cameras-views/$viewId/edit': typeof AuthenticatedCamerasViewsViewIdEditRoute
  '/categories/brand/new': typeof AuthenticatedCategoriesBrandNewRoute
  '/categories/internal/new': typeof AuthenticatedCategoriesInternalNewRoute
  '/categories/reappro/config': typeof AuthenticatedCategoriesReapproConfigRoute
  '/categories/reappro/new': typeof AuthenticatedCategoriesReapproNewRoute
  '/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/daily-sales/stock-min/import': typeof AuthenticatedDailySalesStockMinImportRoute
  '/development/real-estate/$tab': typeof AuthenticatedDevelopmentRealEstateTabRoute
  '/hr/planning/$tab': typeof AuthenticatedHrPlanningTabRoute
  '/pre-authorizations/$sessionId/recordings': typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/sellers/establishment/new': typeof AuthenticatedSellersEstablishmentNewRoute
  '/sensors/fridge/new': typeof AuthenticatedSensorsFridgeNewRoute
  '/administration/roles': typeof AuthenticatedAdministrationRolesIndexRoute
  '/development/real-estate': typeof AuthenticatedDevelopmentRealEstateIndexRoute
  '/hr/planning': typeof AuthenticatedHrPlanningIndexRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdIndexRoute
  '/stores/$storeId': typeof AuthenticatedStoresStoreIdIndexRoute
  '/administration/roles/$roleId/edit': typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  '/stores/$storeId/inventories/$inventoryId': typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  '/administration/roles/$roleId': typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/cameras': typeof AuthenticatedCamerasRouteRouteWithChildren
  '/_authenticated/accounting': typeof AuthenticatedAccountingRoute
  '/_authenticated/cart-photos-x7k2qz': typeof AuthenticatedCartPhotosX7k2qzRoute
  '/_authenticated/cart-vision-checks': typeof AuthenticatedCartVisionChecksRoute
  '/_authenticated/carts': typeof AuthenticatedCartsRoute
  '/_authenticated/carts-control': typeof AuthenticatedCartsControlRoute
  '/_authenticated/feature-flags': typeof AuthenticatedFeatureFlagsRoute
  '/_authenticated/store-pricing': typeof AuthenticatedStorePricingRoute
  '/_authenticated/today': typeof AuthenticatedTodayRoute
  '/_nosidebar/planning': typeof NosidebarPlanningRoute
  '/_authenticated/admins/new': typeof AuthenticatedAdminsNewRoute
  '/_authenticated/cameras-views/new': typeof AuthenticatedCamerasViewsNewRoute
  '/_authenticated/cameras/config': typeof AuthenticatedCamerasConfigRoute
  '/_authenticated/categories/new': typeof AuthenticatedCategoriesNewRoute
  '/_authenticated/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/_authenticated/dashboard/hours': typeof AuthenticatedDashboardHoursRoute
  '/_authenticated/hr/interim-agencies': typeof AuthenticatedHrInterimAgenciesRoute
  '/_authenticated/hr/sms-tracking': typeof AuthenticatedHrSmsTrackingRoute
  '/_authenticated/mailing-lists/$key': typeof AuthenticatedMailingListsKeyRoute
  '/_authenticated/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/_authenticated/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/_authenticated/products/import': typeof AuthenticatedProductsImportRoute
  '/_authenticated/products/new': typeof AuthenticatedProductsNewRoute
  '/_authenticated/promo-campaign/new': typeof AuthenticatedPromoCampaignNewRoute
  '/_authenticated/quality/$lot': typeof AuthenticatedQualityLotRoute
  '/_authenticated/sellers/new': typeof AuthenticatedSellersNewRoute
  '/_authenticated/sensors/new': typeof AuthenticatedSensorsNewRoute
  '/_authenticated/stores/new': typeof AuthenticatedStoresNewRoute
  '/_authenticated/users/new': typeof AuthenticatedUsersNewRoute
  '/_authenticated/visio-reviews/admin': typeof AuthenticatedVisioReviewsAdminRoute
  '/_nosidebar/workshift-attendance/$storeId': typeof NosidebarWorkshiftAttendanceStoreIdRoute
  '/_authenticated/cameras-views/': typeof AuthenticatedCamerasViewsIndexRoute
  '/_authenticated/cameras/': typeof AuthenticatedCamerasIndexRoute
  '/_authenticated/categories/': typeof AuthenticatedCategoriesIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/daily-sales/': typeof AuthenticatedDailySalesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/mailing-lists/': typeof AuthenticatedMailingListsIndexRoute
  '/_authenticated/network-dashboard/': typeof AuthenticatedNetworkDashboardIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/platform-stocks/': typeof AuthenticatedPlatformStocksIndexRoute
  '/_authenticated/pre-authorizations/': typeof AuthenticatedPreAuthorizationsIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/promo-campaign/': typeof AuthenticatedPromoCampaignIndexRoute
  '/_authenticated/quality/': typeof AuthenticatedQualityIndexRoute
  '/_authenticated/sellers/': typeof AuthenticatedSellersIndexRoute
  '/_authenticated/sensors/': typeof AuthenticatedSensorsIndexRoute
  '/_authenticated/stores/': typeof AuthenticatedStoresIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/visio-reviews/': typeof AuthenticatedVisioReviewsIndexRoute
  '/_authenticated/administration/roles/new': typeof AuthenticatedAdministrationRolesNewRoute
  '/_authenticated/admins/$id/edit': typeof AuthenticatedAdminsIdEditRoute
  '/_authenticated/cameras-views/$viewId/edit': typeof AuthenticatedCamerasViewsViewIdEditRoute
  '/_authenticated/categories/brand/new': typeof AuthenticatedCategoriesBrandNewRoute
  '/_authenticated/categories/internal/new': typeof AuthenticatedCategoriesInternalNewRoute
  '/_authenticated/categories/reappro/config': typeof AuthenticatedCategoriesReapproConfigRoute
  '/_authenticated/categories/reappro/new': typeof AuthenticatedCategoriesReapproNewRoute
  '/_authenticated/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/_authenticated/daily-sales/stock-min/import': typeof AuthenticatedDailySalesStockMinImportRoute
  '/_authenticated/development/real-estate/$tab': typeof AuthenticatedDevelopmentRealEstateTabRoute
  '/_authenticated/hr/planning/$tab': typeof AuthenticatedHrPlanningTabRoute
  '/_authenticated/pre-authorizations/$sessionId/recordings': typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  '/_authenticated/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/_authenticated/sellers/establishment/new': typeof AuthenticatedSellersEstablishmentNewRoute
  '/_authenticated/sensors/fridge/new': typeof AuthenticatedSensorsFridgeNewRoute
  '/_authenticated/administration/roles/': typeof AuthenticatedAdministrationRolesIndexRoute
  '/_authenticated/development/real-estate/': typeof AuthenticatedDevelopmentRealEstateIndexRoute
  '/_authenticated/hr/planning/': typeof AuthenticatedHrPlanningIndexRoute
  '/_authenticated/products/$productId/': typeof AuthenticatedProductsProductIdIndexRoute
  '/_authenticated/stores/$storeId/': typeof AuthenticatedStoresStoreIdIndexRoute
  '/_authenticated/administration/roles/$roleId/edit': typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  '/_authenticated/stores/$storeId/inventories/$inventoryId': typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  '/_authenticated/administration/roles/$roleId/': typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/cameras'
    | '/accounting'
    | '/cart-photos-x7k2qz'
    | '/cart-vision-checks'
    | '/carts'
    | '/carts-control'
    | '/feature-flags'
    | '/store-pricing'
    | '/today'
    | '/planning'
    | '/admins/new'
    | '/cameras-views/new'
    | '/cameras/config'
    | '/categories/new'
    | '/companies/new'
    | '/dashboard/hours'
    | '/hr/interim-agencies'
    | '/hr/sms-tracking'
    | '/mailing-lists/$key'
    | '/notifications/$id'
    | '/notifications/new'
    | '/products/import'
    | '/products/new'
    | '/promo-campaign/new'
    | '/quality/$lot'
    | '/sellers/new'
    | '/sensors/new'
    | '/stores/new'
    | '/users/new'
    | '/visio-reviews/admin'
    | '/workshift-attendance/$storeId'
    | '/cameras-views/'
    | '/cameras/'
    | '/categories/'
    | '/companies/'
    | '/daily-sales/'
    | '/dashboard/'
    | '/mailing-lists/'
    | '/network-dashboard/'
    | '/notifications/'
    | '/platform-stocks/'
    | '/pre-authorizations/'
    | '/products/'
    | '/promo-campaign/'
    | '/quality/'
    | '/sellers/'
    | '/sensors/'
    | '/stores/'
    | '/users/'
    | '/visio-reviews/'
    | '/administration/roles/new'
    | '/admins/$id/edit'
    | '/cameras-views/$viewId/edit'
    | '/categories/brand/new'
    | '/categories/internal/new'
    | '/categories/reappro/config'
    | '/categories/reappro/new'
    | '/companies/$id/edit'
    | '/daily-sales/stock-min/import'
    | '/development/real-estate/$tab'
    | '/hr/planning/$tab'
    | '/pre-authorizations/$sessionId/recordings'
    | '/products/$productId/edit'
    | '/sellers/establishment/new'
    | '/sensors/fridge/new'
    | '/administration/roles/'
    | '/development/real-estate/'
    | '/hr/planning/'
    | '/products/$productId/'
    | '/stores/$storeId/'
    | '/administration/roles/$roleId/edit'
    | '/stores/$storeId/inventories/$inventoryId'
    | '/administration/roles/$roleId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/accounting'
    | '/cart-photos-x7k2qz'
    | '/cart-vision-checks'
    | '/carts'
    | '/carts-control'
    | '/feature-flags'
    | '/store-pricing'
    | '/today'
    | '/planning'
    | '/admins/new'
    | '/cameras-views/new'
    | '/cameras/config'
    | '/categories/new'
    | '/companies/new'
    | '/dashboard/hours'
    | '/hr/interim-agencies'
    | '/hr/sms-tracking'
    | '/mailing-lists/$key'
    | '/notifications/$id'
    | '/notifications/new'
    | '/products/import'
    | '/products/new'
    | '/promo-campaign/new'
    | '/quality/$lot'
    | '/sellers/new'
    | '/sensors/new'
    | '/stores/new'
    | '/users/new'
    | '/visio-reviews/admin'
    | '/workshift-attendance/$storeId'
    | '/cameras-views'
    | '/cameras'
    | '/categories'
    | '/companies'
    | '/daily-sales'
    | '/dashboard'
    | '/mailing-lists'
    | '/network-dashboard'
    | '/notifications'
    | '/platform-stocks'
    | '/pre-authorizations'
    | '/products'
    | '/promo-campaign'
    | '/quality'
    | '/sellers'
    | '/sensors'
    | '/stores'
    | '/users'
    | '/visio-reviews'
    | '/administration/roles/new'
    | '/admins/$id/edit'
    | '/cameras-views/$viewId/edit'
    | '/categories/brand/new'
    | '/categories/internal/new'
    | '/categories/reappro/config'
    | '/categories/reappro/new'
    | '/companies/$id/edit'
    | '/daily-sales/stock-min/import'
    | '/development/real-estate/$tab'
    | '/hr/planning/$tab'
    | '/pre-authorizations/$sessionId/recordings'
    | '/products/$productId/edit'
    | '/sellers/establishment/new'
    | '/sensors/fridge/new'
    | '/administration/roles'
    | '/development/real-estate'
    | '/hr/planning'
    | '/products/$productId'
    | '/stores/$storeId'
    | '/administration/roles/$roleId/edit'
    | '/stores/$storeId/inventories/$inventoryId'
    | '/administration/roles/$roleId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/cameras'
    | '/_authenticated/accounting'
    | '/_authenticated/cart-photos-x7k2qz'
    | '/_authenticated/cart-vision-checks'
    | '/_authenticated/carts'
    | '/_authenticated/carts-control'
    | '/_authenticated/feature-flags'
    | '/_authenticated/store-pricing'
    | '/_authenticated/today'
    | '/_nosidebar/planning'
    | '/_authenticated/admins/new'
    | '/_authenticated/cameras-views/new'
    | '/_authenticated/cameras/config'
    | '/_authenticated/categories/new'
    | '/_authenticated/companies/new'
    | '/_authenticated/dashboard/hours'
    | '/_authenticated/hr/interim-agencies'
    | '/_authenticated/hr/sms-tracking'
    | '/_authenticated/mailing-lists/$key'
    | '/_authenticated/notifications/$id'
    | '/_authenticated/notifications/new'
    | '/_authenticated/products/import'
    | '/_authenticated/products/new'
    | '/_authenticated/promo-campaign/new'
    | '/_authenticated/quality/$lot'
    | '/_authenticated/sellers/new'
    | '/_authenticated/sensors/new'
    | '/_authenticated/stores/new'
    | '/_authenticated/users/new'
    | '/_authenticated/visio-reviews/admin'
    | '/_nosidebar/workshift-attendance/$storeId'
    | '/_authenticated/cameras-views/'
    | '/_authenticated/cameras/'
    | '/_authenticated/categories/'
    | '/_authenticated/companies/'
    | '/_authenticated/daily-sales/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/mailing-lists/'
    | '/_authenticated/network-dashboard/'
    | '/_authenticated/notifications/'
    | '/_authenticated/platform-stocks/'
    | '/_authenticated/pre-authorizations/'
    | '/_authenticated/products/'
    | '/_authenticated/promo-campaign/'
    | '/_authenticated/quality/'
    | '/_authenticated/sellers/'
    | '/_authenticated/sensors/'
    | '/_authenticated/stores/'
    | '/_authenticated/users/'
    | '/_authenticated/visio-reviews/'
    | '/_authenticated/administration/roles/new'
    | '/_authenticated/admins/$id/edit'
    | '/_authenticated/cameras-views/$viewId/edit'
    | '/_authenticated/categories/brand/new'
    | '/_authenticated/categories/internal/new'
    | '/_authenticated/categories/reappro/config'
    | '/_authenticated/categories/reappro/new'
    | '/_authenticated/companies/$id/edit'
    | '/_authenticated/daily-sales/stock-min/import'
    | '/_authenticated/development/real-estate/$tab'
    | '/_authenticated/hr/planning/$tab'
    | '/_authenticated/pre-authorizations/$sessionId/recordings'
    | '/_authenticated/products/$productId/edit'
    | '/_authenticated/sellers/establishment/new'
    | '/_authenticated/sensors/fridge/new'
    | '/_authenticated/administration/roles/'
    | '/_authenticated/development/real-estate/'
    | '/_authenticated/hr/planning/'
    | '/_authenticated/products/$productId/'
    | '/_authenticated/stores/$storeId/'
    | '/_authenticated/administration/roles/$roleId/edit'
    | '/_authenticated/stores/$storeId/inventories/$inventoryId'
    | '/_authenticated/administration/roles/$roleId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  NosidebarPlanningRoute: typeof NosidebarPlanningRoute
  NosidebarWorkshiftAttendanceStoreIdRoute: typeof NosidebarWorkshiftAttendanceStoreIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_nosidebar/planning': {
      id: '/_nosidebar/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof NosidebarPlanningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/today': {
      id: '/_authenticated/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AuthenticatedTodayRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/store-pricing': {
      id: '/_authenticated/store-pricing'
      path: '/store-pricing'
      fullPath: '/store-pricing'
      preLoaderRoute: typeof AuthenticatedStorePricingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/feature-flags': {
      id: '/_authenticated/feature-flags'
      path: '/feature-flags'
      fullPath: '/feature-flags'
      preLoaderRoute: typeof AuthenticatedFeatureFlagsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/carts-control': {
      id: '/_authenticated/carts-control'
      path: '/carts-control'
      fullPath: '/carts-control'
      preLoaderRoute: typeof AuthenticatedCartsControlRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/carts': {
      id: '/_authenticated/carts'
      path: '/carts'
      fullPath: '/carts'
      preLoaderRoute: typeof AuthenticatedCartsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cart-vision-checks': {
      id: '/_authenticated/cart-vision-checks'
      path: '/cart-vision-checks'
      fullPath: '/cart-vision-checks'
      preLoaderRoute: typeof AuthenticatedCartVisionChecksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cart-photos-x7k2qz': {
      id: '/_authenticated/cart-photos-x7k2qz'
      path: '/cart-photos-x7k2qz'
      fullPath: '/cart-photos-x7k2qz'
      preLoaderRoute: typeof AuthenticatedCartPhotosX7k2qzRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/accounting': {
      id: '/_authenticated/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AuthenticatedAccountingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras': {
      id: '/_authenticated/cameras'
      path: '/cameras'
      fullPath: '/cameras'
      preLoaderRoute: typeof AuthenticatedCamerasRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/visio-reviews/': {
      id: '/_authenticated/visio-reviews/'
      path: '/visio-reviews'
      fullPath: '/visio-reviews/'
      preLoaderRoute: typeof AuthenticatedVisioReviewsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/': {
      id: '/_authenticated/stores/'
      path: '/stores'
      fullPath: '/stores/'
      preLoaderRoute: typeof AuthenticatedStoresIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sensors/': {
      id: '/_authenticated/sensors/'
      path: '/sensors'
      fullPath: '/sensors/'
      preLoaderRoute: typeof AuthenticatedSensorsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/': {
      id: '/_authenticated/sellers/'
      path: '/sellers'
      fullPath: '/sellers/'
      preLoaderRoute: typeof AuthenticatedSellersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quality/': {
      id: '/_authenticated/quality/'
      path: '/quality'
      fullPath: '/quality/'
      preLoaderRoute: typeof AuthenticatedQualityIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/promo-campaign/': {
      id: '/_authenticated/promo-campaign/'
      path: '/promo-campaign'
      fullPath: '/promo-campaign/'
      preLoaderRoute: typeof AuthenticatedPromoCampaignIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pre-authorizations/': {
      id: '/_authenticated/pre-authorizations/'
      path: '/pre-authorizations'
      fullPath: '/pre-authorizations/'
      preLoaderRoute: typeof AuthenticatedPreAuthorizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/platform-stocks/': {
      id: '/_authenticated/platform-stocks/'
      path: '/platform-stocks'
      fullPath: '/platform-stocks/'
      preLoaderRoute: typeof AuthenticatedPlatformStocksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/network-dashboard/': {
      id: '/_authenticated/network-dashboard/'
      path: '/network-dashboard'
      fullPath: '/network-dashboard/'
      preLoaderRoute: typeof AuthenticatedNetworkDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/mailing-lists/': {
      id: '/_authenticated/mailing-lists/'
      path: '/mailing-lists'
      fullPath: '/mailing-lists/'
      preLoaderRoute: typeof AuthenticatedMailingListsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/daily-sales/': {
      id: '/_authenticated/daily-sales/'
      path: '/daily-sales'
      fullPath: '/daily-sales/'
      preLoaderRoute: typeof AuthenticatedDailySalesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/': {
      id: '/_authenticated/categories/'
      path: '/categories'
      fullPath: '/categories/'
      preLoaderRoute: typeof AuthenticatedCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras/': {
      id: '/_authenticated/cameras/'
      path: '/'
      fullPath: '/cameras/'
      preLoaderRoute: typeof AuthenticatedCamerasIndexRouteImport
      parentRoute: typeof AuthenticatedCamerasRouteRoute
    }
    '/_authenticated/cameras-views/': {
      id: '/_authenticated/cameras-views/'
      path: '/cameras-views'
      fullPath: '/cameras-views/'
      preLoaderRoute: typeof AuthenticatedCamerasViewsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_nosidebar/workshift-attendance/$storeId': {
      id: '/_nosidebar/workshift-attendance/$storeId'
      path: '/workshift-attendance/$storeId'
      fullPath: '/workshift-attendance/$storeId'
      preLoaderRoute: typeof NosidebarWorkshiftAttendanceStoreIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/visio-reviews/admin': {
      id: '/_authenticated/visio-reviews/admin'
      path: '/visio-reviews/admin'
      fullPath: '/visio-reviews/admin'
      preLoaderRoute: typeof AuthenticatedVisioReviewsAdminRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/new': {
      id: '/_authenticated/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AuthenticatedUsersNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/new': {
      id: '/_authenticated/stores/new'
      path: '/stores/new'
      fullPath: '/stores/new'
      preLoaderRoute: typeof AuthenticatedStoresNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sensors/new': {
      id: '/_authenticated/sensors/new'
      path: '/sensors/new'
      fullPath: '/sensors/new'
      preLoaderRoute: typeof AuthenticatedSensorsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/new': {
      id: '/_authenticated/sellers/new'
      path: '/sellers/new'
      fullPath: '/sellers/new'
      preLoaderRoute: typeof AuthenticatedSellersNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quality/$lot': {
      id: '/_authenticated/quality/$lot'
      path: '/quality/$lot'
      fullPath: '/quality/$lot'
      preLoaderRoute: typeof AuthenticatedQualityLotRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/promo-campaign/new': {
      id: '/_authenticated/promo-campaign/new'
      path: '/promo-campaign/new'
      fullPath: '/promo-campaign/new'
      preLoaderRoute: typeof AuthenticatedPromoCampaignNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/new': {
      id: '/_authenticated/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AuthenticatedProductsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/import': {
      id: '/_authenticated/products/import'
      path: '/products/import'
      fullPath: '/products/import'
      preLoaderRoute: typeof AuthenticatedProductsImportRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications/new': {
      id: '/_authenticated/notifications/new'
      path: '/notifications/new'
      fullPath: '/notifications/new'
      preLoaderRoute: typeof AuthenticatedNotificationsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications/$id': {
      id: '/_authenticated/notifications/$id'
      path: '/notifications/$id'
      fullPath: '/notifications/$id'
      preLoaderRoute: typeof AuthenticatedNotificationsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/mailing-lists/$key': {
      id: '/_authenticated/mailing-lists/$key'
      path: '/mailing-lists/$key'
      fullPath: '/mailing-lists/$key'
      preLoaderRoute: typeof AuthenticatedMailingListsKeyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/sms-tracking': {
      id: '/_authenticated/hr/sms-tracking'
      path: '/hr/sms-tracking'
      fullPath: '/hr/sms-tracking'
      preLoaderRoute: typeof AuthenticatedHrSmsTrackingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/interim-agencies': {
      id: '/_authenticated/hr/interim-agencies'
      path: '/hr/interim-agencies'
      fullPath: '/hr/interim-agencies'
      preLoaderRoute: typeof AuthenticatedHrInterimAgenciesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/hours': {
      id: '/_authenticated/dashboard/hours'
      path: '/dashboard/hours'
      fullPath: '/dashboard/hours'
      preLoaderRoute: typeof AuthenticatedDashboardHoursRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/new': {
      id: '/_authenticated/companies/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof AuthenticatedCompaniesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/new': {
      id: '/_authenticated/categories/new'
      path: '/categories/new'
      fullPath: '/categories/new'
      preLoaderRoute: typeof AuthenticatedCategoriesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras/config': {
      id: '/_authenticated/cameras/config'
      path: '/config'
      fullPath: '/cameras/config'
      preLoaderRoute: typeof AuthenticatedCamerasConfigRouteImport
      parentRoute: typeof AuthenticatedCamerasRouteRoute
    }
    '/_authenticated/cameras-views/new': {
      id: '/_authenticated/cameras-views/new'
      path: '/cameras-views/new'
      fullPath: '/cameras-views/new'
      preLoaderRoute: typeof AuthenticatedCamerasViewsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admins/new': {
      id: '/_authenticated/admins/new'
      path: '/admins/new'
      fullPath: '/admins/new'
      preLoaderRoute: typeof AuthenticatedAdminsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/': {
      id: '/_authenticated/stores/$storeId/'
      path: '/stores/$storeId'
      fullPath: '/stores/$storeId/'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/$productId/': {
      id: '/_authenticated/products/$productId/'
      path: '/products/$productId'
      fullPath: '/products/$productId/'
      preLoaderRoute: typeof AuthenticatedProductsProductIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/planning/': {
      id: '/_authenticated/hr/planning/'
      path: '/hr/planning'
      fullPath: '/hr/planning/'
      preLoaderRoute: typeof AuthenticatedHrPlanningIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/development/real-estate/': {
      id: '/_authenticated/development/real-estate/'
      path: '/development/real-estate'
      fullPath: '/development/real-estate/'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/': {
      id: '/_authenticated/administration/roles/'
      path: '/administration/roles'
      fullPath: '/administration/roles/'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sensors/fridge/new': {
      id: '/_authenticated/sensors/fridge/new'
      path: '/sensors/fridge/new'
      fullPath: '/sensors/fridge/new'
      preLoaderRoute: typeof AuthenticatedSensorsFridgeNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sellers/establishment/new': {
      id: '/_authenticated/sellers/establishment/new'
      path: '/sellers/establishment/new'
      fullPath: '/sellers/establishment/new'
      preLoaderRoute: typeof AuthenticatedSellersEstablishmentNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/products/$productId/edit': {
      id: '/_authenticated/products/$productId/edit'
      path: '/products/$productId/edit'
      fullPath: '/products/$productId/edit'
      preLoaderRoute: typeof AuthenticatedProductsProductIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pre-authorizations/$sessionId/recordings': {
      id: '/_authenticated/pre-authorizations/$sessionId/recordings'
      path: '/pre-authorizations/$sessionId/recordings'
      fullPath: '/pre-authorizations/$sessionId/recordings'
      preLoaderRoute: typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hr/planning/$tab': {
      id: '/_authenticated/hr/planning/$tab'
      path: '/hr/planning/$tab'
      fullPath: '/hr/planning/$tab'
      preLoaderRoute: typeof AuthenticatedHrPlanningTabRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/development/real-estate/$tab': {
      id: '/_authenticated/development/real-estate/$tab'
      path: '/development/real-estate/$tab'
      fullPath: '/development/real-estate/$tab'
      preLoaderRoute: typeof AuthenticatedDevelopmentRealEstateTabRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/daily-sales/stock-min/import': {
      id: '/_authenticated/daily-sales/stock-min/import'
      path: '/daily-sales/stock-min/import'
      fullPath: '/daily-sales/stock-min/import'
      preLoaderRoute: typeof AuthenticatedDailySalesStockMinImportRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/companies/$id/edit': {
      id: '/_authenticated/companies/$id/edit'
      path: '/companies/$id/edit'
      fullPath: '/companies/$id/edit'
      preLoaderRoute: typeof AuthenticatedCompaniesIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/reappro/new': {
      id: '/_authenticated/categories/reappro/new'
      path: '/categories/reappro/new'
      fullPath: '/categories/reappro/new'
      preLoaderRoute: typeof AuthenticatedCategoriesReapproNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/reappro/config': {
      id: '/_authenticated/categories/reappro/config'
      path: '/categories/reappro/config'
      fullPath: '/categories/reappro/config'
      preLoaderRoute: typeof AuthenticatedCategoriesReapproConfigRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/internal/new': {
      id: '/_authenticated/categories/internal/new'
      path: '/categories/internal/new'
      fullPath: '/categories/internal/new'
      preLoaderRoute: typeof AuthenticatedCategoriesInternalNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/categories/brand/new': {
      id: '/_authenticated/categories/brand/new'
      path: '/categories/brand/new'
      fullPath: '/categories/brand/new'
      preLoaderRoute: typeof AuthenticatedCategoriesBrandNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cameras-views/$viewId/edit': {
      id: '/_authenticated/cameras-views/$viewId/edit'
      path: '/cameras-views/$viewId/edit'
      fullPath: '/cameras-views/$viewId/edit'
      preLoaderRoute: typeof AuthenticatedCamerasViewsViewIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admins/$id/edit': {
      id: '/_authenticated/admins/$id/edit'
      path: '/admins/$id/edit'
      fullPath: '/admins/$id/edit'
      preLoaderRoute: typeof AuthenticatedAdminsIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/new': {
      id: '/_authenticated/administration/roles/new'
      path: '/administration/roles/new'
      fullPath: '/administration/roles/new'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/$roleId/': {
      id: '/_authenticated/administration/roles/$roleId/'
      path: '/administration/roles/$roleId'
      fullPath: '/administration/roles/$roleId/'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesRoleIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/stores/$storeId/inventories/$inventoryId': {
      id: '/_authenticated/stores/$storeId/inventories/$inventoryId'
      path: '/stores/$storeId/inventories/$inventoryId'
      fullPath: '/stores/$storeId/inventories/$inventoryId'
      preLoaderRoute: typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/administration/roles/$roleId/edit': {
      id: '/_authenticated/administration/roles/$roleId/edit'
      path: '/administration/roles/$roleId/edit'
      fullPath: '/administration/roles/$roleId/edit'
      preLoaderRoute: typeof AuthenticatedAdministrationRolesRoleIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedCamerasRouteRouteChildren {
  AuthenticatedCamerasConfigRoute: typeof AuthenticatedCamerasConfigRoute
  AuthenticatedCamerasIndexRoute: typeof AuthenticatedCamerasIndexRoute
}

const AuthenticatedCamerasRouteRouteChildren: AuthenticatedCamerasRouteRouteChildren =
  {
    AuthenticatedCamerasConfigRoute: AuthenticatedCamerasConfigRoute,
    AuthenticatedCamerasIndexRoute: AuthenticatedCamerasIndexRoute,
  }

const AuthenticatedCamerasRouteRouteWithChildren =
  AuthenticatedCamerasRouteRoute._addFileChildren(
    AuthenticatedCamerasRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCamerasRouteRoute: typeof AuthenticatedCamerasRouteRouteWithChildren
  AuthenticatedAccountingRoute: typeof AuthenticatedAccountingRoute
  AuthenticatedCartPhotosX7k2qzRoute: typeof AuthenticatedCartPhotosX7k2qzRoute
  AuthenticatedCartVisionChecksRoute: typeof AuthenticatedCartVisionChecksRoute
  AuthenticatedCartsRoute: typeof AuthenticatedCartsRoute
  AuthenticatedCartsControlRoute: typeof AuthenticatedCartsControlRoute
  AuthenticatedFeatureFlagsRoute: typeof AuthenticatedFeatureFlagsRoute
  AuthenticatedStorePricingRoute: typeof AuthenticatedStorePricingRoute
  AuthenticatedTodayRoute: typeof AuthenticatedTodayRoute
  AuthenticatedAdminsNewRoute: typeof AuthenticatedAdminsNewRoute
  AuthenticatedCamerasViewsNewRoute: typeof AuthenticatedCamerasViewsNewRoute
  AuthenticatedCategoriesNewRoute: typeof AuthenticatedCategoriesNewRoute
  AuthenticatedCompaniesNewRoute: typeof AuthenticatedCompaniesNewRoute
  AuthenticatedDashboardHoursRoute: typeof AuthenticatedDashboardHoursRoute
  AuthenticatedHrInterimAgenciesRoute: typeof AuthenticatedHrInterimAgenciesRoute
  AuthenticatedHrSmsTrackingRoute: typeof AuthenticatedHrSmsTrackingRoute
  AuthenticatedMailingListsKeyRoute: typeof AuthenticatedMailingListsKeyRoute
  AuthenticatedNotificationsIdRoute: typeof AuthenticatedNotificationsIdRoute
  AuthenticatedNotificationsNewRoute: typeof AuthenticatedNotificationsNewRoute
  AuthenticatedProductsImportRoute: typeof AuthenticatedProductsImportRoute
  AuthenticatedProductsNewRoute: typeof AuthenticatedProductsNewRoute
  AuthenticatedPromoCampaignNewRoute: typeof AuthenticatedPromoCampaignNewRoute
  AuthenticatedQualityLotRoute: typeof AuthenticatedQualityLotRoute
  AuthenticatedSellersNewRoute: typeof AuthenticatedSellersNewRoute
  AuthenticatedSensorsNewRoute: typeof AuthenticatedSensorsNewRoute
  AuthenticatedStoresNewRoute: typeof AuthenticatedStoresNewRoute
  AuthenticatedUsersNewRoute: typeof AuthenticatedUsersNewRoute
  AuthenticatedVisioReviewsAdminRoute: typeof AuthenticatedVisioReviewsAdminRoute
  AuthenticatedCamerasViewsIndexRoute: typeof AuthenticatedCamerasViewsIndexRoute
  AuthenticatedCategoriesIndexRoute: typeof AuthenticatedCategoriesIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedDailySalesIndexRoute: typeof AuthenticatedDailySalesIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedMailingListsIndexRoute: typeof AuthenticatedMailingListsIndexRoute
  AuthenticatedNetworkDashboardIndexRoute: typeof AuthenticatedNetworkDashboardIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedPlatformStocksIndexRoute: typeof AuthenticatedPlatformStocksIndexRoute
  AuthenticatedPreAuthorizationsIndexRoute: typeof AuthenticatedPreAuthorizationsIndexRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedPromoCampaignIndexRoute: typeof AuthenticatedPromoCampaignIndexRoute
  AuthenticatedQualityIndexRoute: typeof AuthenticatedQualityIndexRoute
  AuthenticatedSellersIndexRoute: typeof AuthenticatedSellersIndexRoute
  AuthenticatedSensorsIndexRoute: typeof AuthenticatedSensorsIndexRoute
  AuthenticatedStoresIndexRoute: typeof AuthenticatedStoresIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedVisioReviewsIndexRoute: typeof AuthenticatedVisioReviewsIndexRoute
  AuthenticatedAdministrationRolesNewRoute: typeof AuthenticatedAdministrationRolesNewRoute
  AuthenticatedAdminsIdEditRoute: typeof AuthenticatedAdminsIdEditRoute
  AuthenticatedCamerasViewsViewIdEditRoute: typeof AuthenticatedCamerasViewsViewIdEditRoute
  AuthenticatedCategoriesBrandNewRoute: typeof AuthenticatedCategoriesBrandNewRoute
  AuthenticatedCategoriesInternalNewRoute: typeof AuthenticatedCategoriesInternalNewRoute
  AuthenticatedCategoriesReapproConfigRoute: typeof AuthenticatedCategoriesReapproConfigRoute
  AuthenticatedCategoriesReapproNewRoute: typeof AuthenticatedCategoriesReapproNewRoute
  AuthenticatedCompaniesIdEditRoute: typeof AuthenticatedCompaniesIdEditRoute
  AuthenticatedDailySalesStockMinImportRoute: typeof AuthenticatedDailySalesStockMinImportRoute
  AuthenticatedDevelopmentRealEstateTabRoute: typeof AuthenticatedDevelopmentRealEstateTabRoute
  AuthenticatedHrPlanningTabRoute: typeof AuthenticatedHrPlanningTabRoute
  AuthenticatedPreAuthorizationsSessionIdRecordingsRoute: typeof AuthenticatedPreAuthorizationsSessionIdRecordingsRoute
  AuthenticatedProductsProductIdEditRoute: typeof AuthenticatedProductsProductIdEditRoute
  AuthenticatedSellersEstablishmentNewRoute: typeof AuthenticatedSellersEstablishmentNewRoute
  AuthenticatedSensorsFridgeNewRoute: typeof AuthenticatedSensorsFridgeNewRoute
  AuthenticatedAdministrationRolesIndexRoute: typeof AuthenticatedAdministrationRolesIndexRoute
  AuthenticatedDevelopmentRealEstateIndexRoute: typeof AuthenticatedDevelopmentRealEstateIndexRoute
  AuthenticatedHrPlanningIndexRoute: typeof AuthenticatedHrPlanningIndexRoute
  AuthenticatedProductsProductIdIndexRoute: typeof AuthenticatedProductsProductIdIndexRoute
  AuthenticatedStoresStoreIdIndexRoute: typeof AuthenticatedStoresStoreIdIndexRoute
  AuthenticatedAdministrationRolesRoleIdEditRoute: typeof AuthenticatedAdministrationRolesRoleIdEditRoute
  AuthenticatedStoresStoreIdInventoriesInventoryIdRoute: typeof AuthenticatedStoresStoreIdInventoriesInventoryIdRoute
  AuthenticatedAdministrationRolesRoleIdIndexRoute: typeof AuthenticatedAdministrationRolesRoleIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCamerasRouteRoute: AuthenticatedCamerasRouteRouteWithChildren,
  AuthenticatedAccountingRoute: AuthenticatedAccountingRoute,
  AuthenticatedCartPhotosX7k2qzRoute: AuthenticatedCartPhotosX7k2qzRoute,
  AuthenticatedCartVisionChecksRoute: AuthenticatedCartVisionChecksRoute,
  AuthenticatedCartsRoute: AuthenticatedCartsRoute,
  AuthenticatedCartsControlRoute: AuthenticatedCartsControlRoute,
  AuthenticatedFeatureFlagsRoute: AuthenticatedFeatureFlagsRoute,
  AuthenticatedStorePricingRoute: AuthenticatedStorePricingRoute,
  AuthenticatedTodayRoute: AuthenticatedTodayRoute,
  AuthenticatedAdminsNewRoute: AuthenticatedAdminsNewRoute,
  AuthenticatedCamerasViewsNewRoute: AuthenticatedCamerasViewsNewRoute,
  AuthenticatedCategoriesNewRoute: AuthenticatedCategoriesNewRoute,
  AuthenticatedCompaniesNewRoute: AuthenticatedCompaniesNewRoute,
  AuthenticatedDashboardHoursRoute: AuthenticatedDashboardHoursRoute,
  AuthenticatedHrInterimAgenciesRoute: AuthenticatedHrInterimAgenciesRoute,
  AuthenticatedHrSmsTrackingRoute: AuthenticatedHrSmsTrackingRoute,
  AuthenticatedMailingListsKeyRoute: AuthenticatedMailingListsKeyRoute,
  AuthenticatedNotificationsIdRoute: AuthenticatedNotificationsIdRoute,
  AuthenticatedNotificationsNewRoute: AuthenticatedNotificationsNewRoute,
  AuthenticatedProductsImportRoute: AuthenticatedProductsImportRoute,
  AuthenticatedProductsNewRoute: AuthenticatedProductsNewRoute,
  AuthenticatedPromoCampaignNewRoute: AuthenticatedPromoCampaignNewRoute,
  AuthenticatedQualityLotRoute: AuthenticatedQualityLotRoute,
  AuthenticatedSellersNewRoute: AuthenticatedSellersNewRoute,
  AuthenticatedSensorsNewRoute: AuthenticatedSensorsNewRoute,
  AuthenticatedStoresNewRoute: AuthenticatedStoresNewRoute,
  AuthenticatedUsersNewRoute: AuthenticatedUsersNewRoute,
  AuthenticatedVisioReviewsAdminRoute: AuthenticatedVisioReviewsAdminRoute,
  AuthenticatedCamerasViewsIndexRoute: AuthenticatedCamerasViewsIndexRoute,
  AuthenticatedCategoriesIndexRoute: AuthenticatedCategoriesIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedDailySalesIndexRoute: AuthenticatedDailySalesIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedMailingListsIndexRoute: AuthenticatedMailingListsIndexRoute,
  AuthenticatedNetworkDashboardIndexRoute:
    AuthenticatedNetworkDashboardIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedPlatformStocksIndexRoute: AuthenticatedPlatformStocksIndexRoute,
  AuthenticatedPreAuthorizationsIndexRoute:
    AuthenticatedPreAuthorizationsIndexRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedPromoCampaignIndexRoute: AuthenticatedPromoCampaignIndexRoute,
  AuthenticatedQualityIndexRoute: AuthenticatedQualityIndexRoute,
  AuthenticatedSellersIndexRoute: AuthenticatedSellersIndexRoute,
  AuthenticatedSensorsIndexRoute: AuthenticatedSensorsIndexRoute,
  AuthenticatedStoresIndexRoute: AuthenticatedStoresIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedVisioReviewsIndexRoute: AuthenticatedVisioReviewsIndexRoute,
  AuthenticatedAdministrationRolesNewRoute:
    AuthenticatedAdministrationRolesNewRoute,
  AuthenticatedAdminsIdEditRoute: AuthenticatedAdminsIdEditRoute,
  AuthenticatedCamerasViewsViewIdEditRoute:
    AuthenticatedCamerasViewsViewIdEditRoute,
  AuthenticatedCategoriesBrandNewRoute: AuthenticatedCategoriesBrandNewRoute,
  AuthenticatedCategoriesInternalNewRoute:
    AuthenticatedCategoriesInternalNewRoute,
  AuthenticatedCategoriesReapproConfigRoute:
    AuthenticatedCategoriesReapproConfigRoute,
  AuthenticatedCategoriesReapproNewRoute:
    AuthenticatedCategoriesReapproNewRoute,
  AuthenticatedCompaniesIdEditRoute: AuthenticatedCompaniesIdEditRoute,
  AuthenticatedDailySalesStockMinImportRoute:
    AuthenticatedDailySalesStockMinImportRoute,
  AuthenticatedDevelopmentRealEstateTabRoute:
    AuthenticatedDevelopmentRealEstateTabRoute,
  AuthenticatedHrPlanningTabRoute: AuthenticatedHrPlanningTabRoute,
  AuthenticatedPreAuthorizationsSessionIdRecordingsRoute:
    AuthenticatedPreAuthorizationsSessionIdRecordingsRoute,
  AuthenticatedProductsProductIdEditRoute:
    AuthenticatedProductsProductIdEditRoute,
  AuthenticatedSellersEstablishmentNewRoute:
    AuthenticatedSellersEstablishmentNewRoute,
  AuthenticatedSensorsFridgeNewRoute: AuthenticatedSensorsFridgeNewRoute,
  AuthenticatedAdministrationRolesIndexRoute:
    AuthenticatedAdministrationRolesIndexRoute,
  AuthenticatedDevelopmentRealEstateIndexRoute:
    AuthenticatedDevelopmentRealEstateIndexRoute,
  AuthenticatedHrPlanningIndexRoute: AuthenticatedHrPlanningIndexRoute,
  AuthenticatedProductsProductIdIndexRoute:
    AuthenticatedProductsProductIdIndexRoute,
  AuthenticatedStoresStoreIdIndexRoute: AuthenticatedStoresStoreIdIndexRoute,
  AuthenticatedAdministrationRolesRoleIdEditRoute:
    AuthenticatedAdministrationRolesRoleIdEditRoute,
  AuthenticatedStoresStoreIdInventoriesInventoryIdRoute:
    AuthenticatedStoresStoreIdInventoriesInventoryIdRoute,
  AuthenticatedAdministrationRolesRoleIdIndexRoute:
    AuthenticatedAdministrationRolesRoleIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  NosidebarPlanningRoute: NosidebarPlanningRoute,
  NosidebarWorkshiftAttendanceStoreIdRoute:
    NosidebarWorkshiftAttendanceStoreIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
